/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SandboxProvider,
  SandboxProvider$inboundSchema,
  SandboxProvider$outboundSchema,
} from "./sandboxprovider.js";
import {
  SessionRecord,
  SessionRecord$inboundSchema,
  SessionRecord$Outbound,
  SessionRecord$outboundSchema,
} from "./sessionrecord.js";

export type CreateSessionResponse = {
  session: SessionRecord;
  sessionToken?: string | null | undefined;
  provider?: SandboxProvider | null | undefined;
};

/** @internal */
export const CreateSessionResponse$inboundSchema: z.ZodType<
  CreateSessionResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  session: SessionRecord$inboundSchema,
  session_token: z.nullable(z.string()).optional(),
  provider: z.nullable(SandboxProvider$inboundSchema).optional(),
}).transform((v) => {
  return remap$(v, {
    "session_token": "sessionToken",
  });
});
/** @internal */
export type CreateSessionResponse$Outbound = {
  session: SessionRecord$Outbound;
  session_token?: string | null | undefined;
  provider?: string | null | undefined;
};

/** @internal */
export const CreateSessionResponse$outboundSchema: z.ZodType<
  CreateSessionResponse$Outbound,
  z.ZodTypeDef,
  CreateSessionResponse
> = z.object({
  session: SessionRecord$outboundSchema,
  sessionToken: z.nullable(z.string()).optional(),
  provider: z.nullable(SandboxProvider$outboundSchema).optional(),
}).transform((v) => {
  return remap$(v, {
    sessionToken: "session_token",
  });
});

export function createSessionResponseToJSON(
  createSessionResponse: CreateSessionResponse,
): string {
  return JSON.stringify(
    CreateSessionResponse$outboundSchema.parse(createSessionResponse),
  );
}
export function createSessionResponseFromJSON(
  jsonString: string,
): SafeParseResult<CreateSessionResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateSessionResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateSessionResponse' from JSON`,
  );
}
